module.exports = __webpack_public_path__ + "static/media/user.f8e74d7f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user.svg
// module id = 1282
// module chunks = 1